import { IModule } from 'redux-state/layout/types.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { ModuleLoad } from './module-load.js';

export type ModuleLoadCB = () => void;

/** Lazy load module */
export const ModuleArrLoad = ({
  modules = [],
  modulePath,
  isStaticMapSlot,
}: {
  modules: IModule<IModuleConfig, 'Raw'>['config'][] | undefined;
  modulePath: ModulePath;
  isStaticMapSlot?: boolean;
}) => {
  return (
    <>
      {modules.map((config, i) => {
        return (
          <ModuleLoad
            key={`${config.name}-${i}`}
            config={config}
            modulePath={modulePath}
            isStaticMapSlot={isStaticMapSlot}
          />
        );
      })}
    </>
  );
};
